import type { VariationType } from '#utils/flags/flagConstants';

import { VariationValue } from './variationInstructionListItemUtils';

import styles from './styles.module.css';

export type AddVariationInstructionEntryProps = {
  variationType: VariationType;
  name?: string;
  description?: string;
  value: string;
};

export function AddVariationInstructionEntry({
  variationType,
  value,
  name,
  description,
}: AddVariationInstructionEntryProps) {
  const labelFlexBasis = description ? '6.25rem' : '3.75rem';

  return (
    <div className={styles.VariationInstructionEntry}>
      <ul className={styles.ChangeList}>
        {name ? (
          <li className={styles.ChangeEntry}>
            <span className={styles.changeEntryLabel} style={{ flexBasis: labelFlexBasis }}>
              Name:
            </span>
            <span className={styles.MetadataValue}>{name}</span>
          </li>
        ) : null}
        {description ? (
          <li className={styles.ChangeEntry}>
            <span className={styles.changeEntryLabel} style={{ flexBasis: labelFlexBasis }}>
              Description:
            </span>
            <span className={styles.MetadataValue}>{description}</span>
          </li>
        ) : null}
        <li className={styles.ChangeEntry}>
          <span className={styles.changeEntryLabel} style={{ flexBasis: labelFlexBasis }}>
            Value:
          </span>
          <span>
            <VariationValue value={value} variationType={variationType} />
          </span>
        </li>
      </ul>
    </div>
  );
}
